<template>
  <div>
    <div class="inactive" v-if="!active" @click="addTag">
      {{ name }} +
    </div>
    <div class="active" v-else @click="removeTag">
      {{ name }} <img src="../../assets/active-tag.svg" alt=""  />
    </div>
  </div>
</template>

<script>
export default {
  name: 'JobTag',
  props: {
    name: {
      type: String,
      default: 'Permanent'
    },
    active: {
      type: Boolean,
      default: false
    },
    value: {
      type: String | Object
    }
  },
  methods: {
    addTag () {
      this.$emit('addTag', this.value)
    },
    removeTag () {
      this.$emit('removeTag', this.value)
    }
  }

}
</script>

<style scoped>
.active {
  background: #44c7f0;
  border-radius: 25px;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  text-align: center;
  color: #ffffff;
  padding: 7px 14px;
  cursor: pointer;
}

.inactive {
  background: rgba(68, 199, 240, 0.15);
  border-radius: 25px;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  text-align: center;
  color: #44c7f0;
  padding: 7px 14px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/general/job-tag.vue